import { LoaderFunctionArgs } from 'react-router-dom';
import { QrUpload } from 'qr-upload-sdk';
import { Config } from '../../consts/config';
import getToken from '../../auth/getToken';

/**
 * QR Upload Loader - EXACTLY like sparkl-web's preJoining loader
 * Initializes SDK with existing user.sso_token (like sparkl-web main.jsx)
 */
export const qrUploadLoader = async ({ params }: LoaderFunctionArgs) => {
  console.log('QR Upload Loader - Starting (like sparkl-web preJoining)');
  
  const testId = params.testId;
  
  if (!testId) {
    console.error('No testId provided');
    return { testData: null };
  }

  try {
    if (!window.qrUploadSdk) {
      window.qrUploadSdk = new QrUpload();
      console.log('Global QrUpload SDK instance created');
    }

    const sdk = window.qrUploadSdk;
    
    const userStr = localStorage.getItem('user');
    if (!userStr) {
      console.error('No user found in localStorage');
      return { testData: null };
    }
    
    const user = JSON.parse(userStr);
    console.log('User from localStorage:', { 
      hasUser: !!user,
      hasToken: !!user?.token,
      hasSSOToken: !!user?.sso_token,
      userId: user?.user?.id 
    });

    if (!user || !user.user) {
      console.error('Invalid user data');
      return { testData: null };
    }

    const url = new URL(window.location.href);
    const assessmentId = url.searchParams.get('assessmentId');
    
    console.log('Assessment info:', { testId, assessmentId });

    const qrUploadInit = async () => {
      console.log('Initializing SDK (sparkl-web pattern)...');
      
      if (!user.sso_token) {
        console.error('User missing sso_token - cannot generate QR URL');
        return;
      }

      const sdkConfig = {
        qrUrl: {
          // EXACT sparkl-web pattern: use existing user.sso_token
          frontendUrl: `${Config.FRONTEND_URL}/sso/${testId}?sso=${user.sso_token}&type=qr-upload`,
        },
        fetchApi: {
          url: `${Config.BACKEND_DOMAIN || Config.API_URL?.replace('/api/', '')}/velocity/v1/assessment/${assessmentId}/upload-response`,
          headers: {
            'X-User-Id': user.user.id,
            'X-User-Type': user.user.type,
            'token': user.token,
          },
          responseKey: 'data',
        },
        enablePolling: false, // Disable polling for sparkl-fe
        uploadApi: {
          url:`${Config.BACKEND_DOMAIN || Config.API_URL?.replace('/api/', '')}/velocity/v1/assessment/${assessmentId}/upload-response`,
          headers: {
            "X-User-Type": user.user.type,
            "X-User-Id": user.user.id,
            "token": user.token,
          },
          body: {},
          fileKey: "answer_sheet_file",
          onUploadImageSuccess: (uploadedFiles: any[]) => {
            console.log('Files uploaded successfully:', uploadedFiles);
            try {
              window.dispatchEvent(new CustomEvent('qr-upload:upload-success', {
                detail: { uploadedFiles },
              }));
            } catch (error) {
              console.error('QR Upload Loader - Error dispatching upload success event:', error);
            }
          }
        },
        useNativeCamera: true,
        enableImageEditor: true,
        logoUrl: 'https://www.sparkl.me/assets/img/seo_pages/header/sparkl_header_logo_black.png',
        imageConfig: {
          multiPhoto: true,
          maxImages: 100,
          allowedMimeTypes: ["image/jpeg", "image/png", "image/webp"],
          fileName: new URLSearchParams(window.location.search).get('slideNumber') || '1',
        },
      };

      console.log('QR URL (sparkl-web pattern):', sdkConfig.qrUrl.frontendUrl);
      console.log('Upload URL:', sdkConfig.uploadApi.url);

      sdk.init(sdkConfig);
      console.log('SDK initialized successfully (sparkl-web pattern)');
    };

    await qrUploadInit();

    return {
      testData: {
        test_id: testId,
        assessment_id: assessmentId,
      },
    };

  } catch (error) {
    console.error('QR Upload Loader error:', error);
    return { testData: null };
  }
};

